import {NgForOf, NgIf} from '@angular/common';
import {ChangeDetectionStrategy, Component, ElementRef, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {NbActionsModule, NbAutocompleteModule, NbInputModule} from '@nebular/theme';
import {BaseComponent} from 'compob2b-libs';
import {distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {TuiIcon} from '@taiga-ui/core'

@Component({
  selector: 'app-menu-search',
  templateUrl: './menu-search.component.html',
  styleUrls: ['./menu-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NbAutocompleteModule,
    NbInputModule,
    ReactiveFormsModule,
    NgForOf,
    NgIf,
    NbActionsModule,
    TuiIcon
  ]
})
export class MenuSearch extends BaseComponent implements OnInit {
  @Input() menuItems: any[] = [];
  searchControl = new UntypedFormControl()
  searchMatches: any[];
  search = false;

  @ViewChild('searchInput', {static: false}) searchInput: ElementRef;

  ngOnInit() {
    this.searchControl.valueChanges
      .pipe(
        takeUntil(this.unsubscribe),
        distinctUntilChanged(),
      )
      .subscribe(term => {
        if (term && typeof term === 'object') {
          this.selectMenuItem(term);
        } else {
          this.searchMenuElements(term?.trim());
        }
      });
  }

  searchMenuElements(term) {
    this.searchMatches = [];
    if (term?.length) {
      this.recursiveSearch(this.menuItems, this.compoApiService.stringToKeyCodes(term));
    }
    this.cdr.detectChanges();
  }

  selectMenuItem(item) {
    this.searchControl.patchValue('');

    if (item && item.hasOwnProperty('link')) {
      this.router.navigate([item.link]);
    }
  }

  recursiveSearch(obj, title) {
    obj.forEach((item) => {
      if (
        item.hasOwnProperty('link') &&
        this.compoApiService.stringToKeyCodes(item.title).indexOf(title) > -1
      ) {
        this.searchMatches.push(item);
      }

      if (item.children && item.children.length > 0) {
        this.recursiveSearch(item.children, title);
      }
    });
  }

  get isMac() {
    return window.navigator && /(Mac|iPhone|iPod|iPad)/i.test(window.navigator.platform);
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if ((event.code == 'KeyK' || event.key === 'k') && (event.ctrlKey || event.metaKey)) {
      event.preventDefault();
      this.openSearch(true);
    }
  }

  openSearch(force = false) {
    this.search = true;
    this.cdr.detectChanges();
    if (force) {
      this.searchInput.nativeElement.focus();
    }
  }

  closeSearch(force = false) {
    console.log(force, document.activeElement, document.activeElement == this.searchInput.nativeElement);
    if (!force && document.activeElement == this.searchInput.nativeElement) {
      return;
    }
    this.search = false;
    this.cdr.detectChanges();
  }

}
